module.exports = __webpack_public_path__ + "static/img/serve-icon.eae4d22d.png";